import type { PartyResult } from '@val/shared'
import { getParty } from '@val/shared'
import { int, pct, signed } from '../lib/format.ts'
import './partybars.css'

interface Props {
  parties: PartyResult[]
  highlightParty?: string
  showComparison?: boolean
}

export function PartyBars({ parties, highlightParty, showComparison = true }: Props) {
  const rows = [...parties].sort(
    (a, b) => b.seatsComputed - a.seatsComputed || b.votes - a.votes || b.pct - a.pct,
  )
  const maxPct = Math.max(1, ...rows.map((r) => r.pct))

  return (
    <div className="partybars">
      {rows.map((r) => {
        const meta = getParty(r.code)
        const seatDelta = r.seats2022 != null ? r.seatsComputed - r.seats2022 : null
        const isHi = r.code === highlightParty
        return (
          <div key={r.code} className={`pb-row${isHi ? ' is-highlight' : ''}`}>
            <div className="pb-row__party">
              <span className="pb-chip" style={{ background: meta.color, color: meta.onColor }}>
                {meta.shortName}
              </span>
              <span className="pb-name">{meta.name}</span>
            </div>

            <div className="pb-row__bar">
              <div
                className="pb-bar"
                style={{ width: `${(r.pct / maxPct) * 100}%`, background: meta.color }}
              />
              <span className="pb-bar__pct tnum">{pct(r.pct)}</span>
            </div>

            <div className="pb-row__votes tnum">{int(r.votes)}</div>

            <div className="pb-row__seats tnum">
              <span className="pb-seats">{r.seatsComputed}</span>
              {showComparison && seatDelta != null ? (
                <span className={`pb-delta ${seatDelta > 0 ? 'up' : seatDelta < 0 ? 'down' : ''}`}>
                  {signed(seatDelta)}
                </span>
              ) : null}
            </div>
          </div>
        )
      })}
      <div className="pb-legend dim">
        <span>Parti</span>
        <span>Andel</span>
        <span>Röster</span>
        <span>Mandat {showComparison ? '(mot 2022)' : ''}</span>
      </div>
    </div>
  )
}
